import { DB } from '_c/typings/model/db';
import { defineComponent, inject, PropType } from 'vue';
import KkImage from '@/component/kk-image/kk-image.vue';
import { IMsg } from '_c/typings/model/im';
import { report } from '_c/business/api/report';
import { UserManager } from '_c/business/manager/user';
// import { report } from '_c/business/api/report';

/** 文本链接解析内容 */
export default defineComponent({
  name: 'TextLinkContent',
  components: {
    KkImage,
  },
  props: {
    linkMsgInfo: {
      type: Object as PropType<DB.ILinkMsgInfo>,
      default: () => null,
    },
  },
  setup(): {
    messageData: IMsg
  } {
    return {
      messageData: inject('messageData') as IMsg,
    };
  },
  data() {
    return {

    };
  },
  computed: {

  },
  methods: {
    onClickHandler() {
      const link = this.linkMsgInfo?.link;
      if (link) window.open(link);
      const uid = UserManager.getInstance().getCurrentUid();
      const userType = UserManager.getInstance().getUser(uid)?.userType?.toString() ?? '0';
      report({
        reportParamsList: [{
          operId: '1916000110201',
          groupId: this.$store.state.group.selectGroupId,
          channelId: this.$store.state.group.selectChannelId || '0',
          messageType: this.messageData.l2Type,
          toUid: this.messageData.senderUid,
          ext1: userType,
          messageId: this.messageData.origin?.ID,
        }],
      });
    },
  },
});
